/* Copyright (c) 2024 Xperi. All Rights Reserved. */
export const SET_ONE_LINE_GUIDE_ACTIVE = 'SET_ONE_LINE_GUIDE_ACTIVE';

export const SET_ONE_LINE_GUIDE_ARE_CHANNELS_SELECTED = 'SET_ONE_LINE_GUIDE_ARE_CHANNELS_SELECTED';

export const SET_ONE_LINE_GUIDE_CELL_AIRING_NOW = 'SET_ONE_LINE_GUIDE_CELL_AIRING_NOW';

export const SET_ONE_LINE_GUIDE_CELL_SELECTED = 'SET_ONE_LINE_GUIDE_CELL_SELECTED';

export const SET_ONE_LINE_GUIDE_CELLS_DELETE = 'SET_ONE_LINE_GUIDE_CELLS_DELETE';

export const SET_ONE_LINE_GUIDE_CELLS_APPEND = 'SET_ONE_LINE_GUIDE_CELLS_APPEND';

export const SET_ONE_LINE_GUIDE_CELLS_PREPEND = 'SET_ONE_LINE_GUIDE_CELLS_PREPEND';

export const SET_ONE_LINE_GUIDE_CURRENT_SELECTED_CELL_STAR_RATING =
    'SET_ONE_LINE_GUIDE_CURRENT_SELECTED_CELL_STAR_RATING';

export const SET_ONE_LINE_GUIDE_CHANNELS = 'SET_ONE_LINE_GUIDE_CHANNELS';

export const SET_ONE_LINE_GUIDE_EMPTY = 'SET_ONE_LINE_GUIDE_EMPTY';

export const SET_ONE_LINE_GUIDE_ERROR = 'SET_ONE_LINE_GUIDE_ERROR';

export const SET_ONE_LINE_GUIDE_INACTIVE = 'SET_ONE_LINE_GUIDE_INACTIVE';

export const SET_ONE_LINE_GUIDE_IS_CONTENT_FETCHED = 'SET_ONE_LINE_GUIDE_IS_CONTENT_FETCHED';

export const SET_ONE_LINE_GUIDE_IS_FUTURE_MODE = 'SET_ONE_LINE_GUIDE_IS_FUTURE_MODE';

export const SET_ONE_LINE_GUIDE_HIDDEN = 'SET_ONE_LINE_GUIDE_HIDDEN';

export const SET_ONE_LINE_GUIDE_SELECTED_CHANNEL = 'SET_ONE_LINE_GUIDE_SELECTED_CHANNEL';

export const SET_ONE_LINE_GUIDE_CURRENT_OFFER_PREVIEW = 'SET_ONE_LINE_GUIDE_CURRENT_OFFER_PREVIEW';

export const SET_ONE_LINE_GUIDE_CURRENTLY_AIRING_CHANNEL =
    'SET_ONE_LINE_GUIDE_CURRENTLY_AIRING_CHANNEL';

export const SET_ONE_LINE_GUIDE_TIME_STAMP = 'SET_ONE_LINE_GUIDE_TIME_STAMP';

export const SET_ONE_LINE_GUIDE_ARE_FUTURE_CELLS_RECEIVED =
    'SET_ONE_LINE_GUIDE_ARE_FUTURE_CELLS_RECEIVED';

export const SET_ONE_LINE_GUIDE_ARE_PAST_CELLS_RECEIVED =
    'SET_ONE_LINE_GUIDE_ARE_PAST_CELLS_RECEIVED';

export const UPDATE_ONE_LINE_GUIDE_AIRING_NOW_TIMEOUT = 'UPDATE_ONE_LINE_GUIDE_AIRING_NOW_TIMEOUT';

export const UPDATE_ONE_LINE_GUIDE_INACTIVITY_TIMEOUT = 'UPDATE_ONE_LINE_GUIDE_INACTIVITY_TIMEOUT';

export const UPDATE_ONE_LINE_GUIDE_STICKINESS_TIMEOUT = 'UPDATE_ONE_LINE_GUIDE_STICKINESS_TIMEOUT';

export const SET_ONE_LINE_GUIDE_TURBO_SCROLL = 'SET_ONE_LINE_GUIDE_TURBO_SCROLL';

export const SET_ONE_LINE_GUIDE_HORIZONTAL_SCROLL = 'SET_ONE_LINE_GUIDE_HORIZONTAL_SCROLL';
